goog.provide('yext.storm.OptimizationReport');

/**
 * Optimization Report
 *
 * @author Matt Spencer (matt@yext.com)
 */
(function(window, document, undefined) {
  var OptimizationReport = function(options) {
    this.bindPrintReport();
    this.bindOptedOutButtons();
  };

  goog.exportSymbol('OptimizationReport', OptimizationReport);

  /**
   * Binds link to print the optimization report
   */
  OptimizationReport.prototype.bindPrintReport = function() {
    $('.js-print-report').click(function() {
      window.print();
    });
  };

  /**
   * Bind opted out button hover and click to opt in and then redirect tp goal
   */
  OptimizationReport.prototype.bindOptedOutButtons = function() {
    $('#optimization-report-sections').on('mouseleave mouseenter', '.js-opted-out-wrap', function(e) {
      var $self = $(this);
      var mouseenter = e.type === 'mouseenter';

      $self.find('.js-opted-out').toggle(!mouseenter);
      $self.find('.js-opt-in').toggle(mouseenter);
    });
  };
})(window, document);
